import { baseCRUDAPI } from './base';

export default class Events extends baseCRUDAPI {
  constructor(axiosObject) {
    super(axiosObject, 'Event');
  }

  async getEventTypeSolutions() {
    return this.axiosObject.get(
      `${this.apiBaseName}/GetEventTypeSolutions`,
    );
  }

  async submitQuestion({
    eventId,
    askerEmail,
    questionText,
  }) {
    return this.axiosObject.put(
      `${this.apiBaseName}/Question`,
      {
        eventId,
        askerEmail,
        questionText,
        eventQuestionTypeId: '06E7A656-C0AB-4F99-94D0-8715E29B77F8',
      },
    );
  }

  async register(inputs) {
    return this.axiosObject.put(
      `${this.apiBaseName}/QuickRegister`,
      inputs,
    );
  }

  async signIn({ id, eventId, email }) {
    return this.axiosObject.put(
      `${this.apiBaseName}/SignIn`,
      {
        id,
        eventId,
        email,
      },
    );
  }

  async loadEvent({ id, email }) {
    const url = email
      ? `${this.apiBaseName}/${id}?email=${email}`
      : `${this.apiBaseName}/${id}`;

    return this.axiosObject.get(url);
  }
}
